module.exports = __webpack_public_path__ + "static/media/favicon.ebe5cf28.ico";